import { render, staticRenderFns } from "./VenueForm.vue?vue&type=template&id=e32e3764"
import script from "./VenueForm.vue?vue&type=script&lang=js"
export * from "./VenueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports